var ModalEnum;
(function (ModalEnum) {
    ModalEnum["Login"] = "login";
    ModalEnum["Warning"] = "warning";
    ModalEnum["Welcome"] = "welcome";
})(ModalEnum || (ModalEnum = {}));
export { ModalEnum };
